import React from 'react'
import { Link } from 'gatsby'

export default () => {
  return (
    <p>
      By using this website you accept our <Link to="/cookie-policy">Cookie policy</Link>
    </p>
  )
}
